(function ($) {
  'use strict';

  function mainSlider() {
    var $slideshow = $('.home-slider');
    $slideshow.owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag: false,
      touchDrag: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      nav: false,
      loop: true,
      lazyContent: true,
      autoplay: true,
      autoplayTimeout: 5000
    });
  }

  function owlSlider() {
    $('.related-products-items.owl-carousel').owlCarousel({
      loop: true,
      margin: 15,
      nav: true,
      dots: false,
      lazyLoad: true,
      responsiveClass: true,

      responsive: {
        0: {
          items: 2,
          margin: 5,
          nav: true
        },
        600: {
          items: 3,
          margin: 10,
          nav: true
        },
        1000: {
          items: 4,
          nav: true
        }
      }
    });

    // Post Slider
    $('.home-post__slider').owlCarousel({
      loop: false,
      margin: 0,
      nav: true,
      dots: true,
      lazyLoad: true,
      responsiveClass: true,

      responsive: {
        0: {
          items: 1,
          margin: 0,
          nav: true,
          dots: true
        },
        600: {
          items: 2,
          margin: 0,
          nav: true,
          dots: true
        },
        1000: {
          items: 3,
          nav: true,
          dots: true
        }
      }
    });

    //Home Product Slider
    if ($(window).width() > 768) {
      $('.home-products__slider').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        dots: false,
        lazyLoad: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 2
          },
          993: {
            items: 3
          }
        }
      });

      $('.home-products__slider-arrows .prev-arrow').click(function () {
        $('.home-products__slider .owl-prev').trigger('click');
      });

      $('.home-products__slider-arrows .next-arrow').click(function () {
        $('.home-products__slider .owl-next').trigger('click');
      });
    }

    //Charity Card Page
    $('.page-charity-card-slideshow').owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      nav: true,
      loop: true,
      lazyContent: true,
      autoplay: true,
      autoplayTimeout: 5000
    });

    //Collection slideshow
    $('.collection-slideshow-wrap').owlCarousel({
      items: 4,
      margin: 30,
      stagePadding: 0,
      nav: true,
      dots: false,
      loop: true,
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          stagePadding: 60,
          margin: 15,
          nav: false
        },
        481: {
          items: 1,
          stagePadding: 100,
          nav: false
        },
        600: {
          items: 2
        },
        769: {
          items: 3
        },
        1081: {
          items: 4
        }
      }
    });
  }

  function scrollHash() {
    $("a.scroll-hash").on('click', function (event) {

      // Make sure this.hash has a value before overriding default behavior
      if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
          scrollTop: $(hash).offset().top - 180
        }, 1000, function () {

          // Add hash (#) to URL when done scrolling (default click behavior)
          //window.location.hash = hash;
        });
      } // End if
    });
  }

  function accordionTabs() {
    $('.accordion').accordion({
      "transitionSpeed": 100
    });
  }

  //Sticky Header
  var stickyNav = function () {
    var stickyElement = $(".site-header"),
      stickyClass = "isStuck",
      stickyPos = stickyElement.offset().top, //Distance from the top of the window.
      stickyHeight;

    //Create a negative margin to prevent content 'jumps':
    stickyElement.after('<div class="jumps-prevent"></div>');
    function jumpsPrevent() {
      stickyHeight = stickyElement.innerHeight();
      stickyElement.css({ "margin-bottom": "-" + stickyHeight + "px" });
      stickyElement.next().css({ "padding-top": + stickyHeight + "px" });
    };
    jumpsPrevent(); //Run.
    
    //Function trigger:
    $(window).resize(function () {
      jumpsPrevent();
    });

    //Sticker function:
    function stickerFn() {
      var winTop = $(window).scrollTop();
      //Check element position:

      if (stickyPos < 0 && winTop == 0) {
        stickyElement.removeClass(stickyClass);
      } else if (winTop >= stickyPos && winTop != 0) {
        stickyElement.addClass(stickyClass);
      } else if (winTop == 0 && stickyPos == 0) {
        stickyElement.removeClass(stickyClass);
      } else {
        stickyElement.removeClass(stickyClass);
      }
    };
    stickerFn(); //Run.

    //Function trigger:
    $(window).scroll(function () {
      stickerFn();
    });
  }
  // End Sticky Header

  function testimonial() {
    $('.testimonial-slider').owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      mouseDrag: false,
      items: 1,
      margin: 0,
      stagePadding: 0,
      smartSpeed: 450,
      nav: true,
      loop: true,
      lazyContent: true,
      autoplay: true,
      autoplayTimeout: 7000,
      autoHeight: true,

      responsive: {
        0: {
          nav: false,
          dots: true
        },
        600: {
          nav: false,
          dots: true
        },
        1000: {
          nav: true,
          dots: true
        }
      }
    });
  }

  function ctaPopup() {
    $('.cta__btn').magnificPopup({
      type: 'inline',

      fixedContentPos: true,
      fixedBgPos: true,

      overflowY: 'auto',

      closeBtnInside: true,
      preloader: false,

      midClick: true,
      removalDelay: 300,
      mainClass: 'cta-popup__container my-mfp-slide-bottom'
    });
  }

  function videoPopup() {
    $('.video--popup').magnificPopup({
      disableOn: false,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false
    });
  }

  /* Search bar */
  var searchContainer = $('#header-search-bar'),
      searchOpen = $('.site-header__search-trigger'),
      searchClose = searchContainer.find('.site-header__search-close');

  searchOpen.click(function (evt) {
    var searchContainer = $('#header-search-bar'),
        searchOpen = $('.site-header__search-trigger'),
        searchClose = searchContainer.find('.site-header__search-close');
    evt.preventDefault();

    if (searchContainer.hasClass('active')) {
      searchContainer.removeClass('active');
    } else {
      searchContainer.addClass('active');
      setTimeout(function () {
        searchContainer.find('input#search-bar__input').focus();
      }, 500);
    }
  })

  searchClose.click(function () {
    searchContainer.removeClass('active');
  });  

  function mobileFooter() {
    $('.site-footer__column > h3 > .mobile-clicker').click(function () {
      var $this = $(this).parents('.site-footer__column');
      $this.siblings().removeClass('open');

      if ($this.hasClass('open')) {
        $this.removeClass('open');
      } else {
        $this.addClass('open');
      }
    })
  }

  function homeLogoWithTextSlider() {
    $('.home-logo-with-text-slider-top').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      asNavFor: '.home-logo-with-text-slider-bottom',
      responsive: [
        {
          breakpoint: 769,
          settings: {
            dots: true,
            arrows: true
          }
        }
      ]
    });
    $('.home-logo-with-text-slider-bottom').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.home-logo-with-text-slider-top',
      arrows: false,
      dots: false,
      focusOnSelect: true
    });
  }

  function collectionMobileMenu() {
    // set position
    // var headerPosition = $('.header-top').offset().top + $('.header-top').height() - $(window).scrollTop();
    // $('.collection-mobile-menu').css('top', headerPosition);

    // $(window).scroll(function () {
    //   var headerPosition = $('.header-top').offset().top + $('.header-top').height() - $(window).scrollTop();
    //   $('.collection-mobile-menu').css('top', headerPosition);
    // });

    // toggle
    $('.collection-mobile-menu .menu-title').click(function () {
      $('.collection-mobile-menu ul').slideToggle();
      $('.collection-mobile-menu .menu-title').toggleClass('active');
    });
  }

  function backToTopButton() {
    $(window).scroll(function () {
      var wScroll = $(window).scrollTop();
      if (wScroll > 500) {
        $("#backToTopButton").addClass("active");
      } else {
        $("#backToTopButton").removeClass("active");
      }
    });
    //Click event to scroll to top
    $("#backToTopButton").click(function () {
      $("html, body").animate({ scrollTop: 0 }, 800);
      return false;
    });
  }

  function announcementSlider() {
    $('.announcement-slider-wrap').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000
    });
  }
  
  
  $(document).ready(function () {
  	stickyNav();
    scrollHash();
    ctaPopup();
    //new WOW().init();
    testimonial();
    owlSlider();
    mainSlider();
    videoPopup();
    accordionTabs();
    mobileFooter();
    homeLogoWithTextSlider();
    collectionMobileMenu();
    backToTopButton();
    announcementSlider();

    $('.tooltip').tooltipster({
      animation: 'fade',
      delay: 100,
      contentCloning: true,
      theme: 'tooltipster-shadow'
    });

    lazySizes.init();

//     $(window).load(function () {
//       $('.preloader').addClass('none');
//     });

    // Close cart drawer
    $('#NavOverlay').click(function () {
      $('.js-drawer-close').trigger('click');
    });


    //     $('.site-nav--has-dropdown > a').click(function (e) {
    //       e.preventDefault();
    //       var $this = $(this).parent(),
    //           $navOverlay = $('#NavOverlay');
    //       $this.siblings().removeClass('dropdown--active');
    //       $navOverlay.removeClass('nav-overlay--active');
    //       if ($this.hasClass('dropdown--active')) {
    //         $navOverlay.removeClass('nav-overlay--active');
    //         $this.removeClass('dropdown--active').parents('.site-header').removeClass('header--active');
    //       } else {
    //         $navOverlay.addClass('nav-overlay--active');
    //         $this.addClass('dropdown--active').parents('.site-header').addClass('header--active');
    //       }

    //     });

    //     $('#NavOverlay').click(function () {
    //       var $this = $(this);
    //       $this.removeClass('nav-overlay--active');
    //       $('.site-nav--has-dropdown').removeClass('dropdown--active').parents('.site-header').removeClass('header--active');
    //     });
  });


  $(window).load(function () {
    $('body').css('opacity', '1');
    
    $('.cart-item__qty .js-qty__adjust').click(function () {
      $('.update-cart').trigger('click');
    });

    // add to cart button - mobile
    //$('.product-single__controls .product-single__submit').addClass('active');
  });
})(jQuery);
